export const staffAttendance = [
  {
    id: "EA123794",
    student_name: "Janet",
    rollNo: "Roll No : 35013",
    department: "Admin",
    designation: "Technical Head",
    english: "green",
    spanish: "green",
    physics: "green",
    chemistry: "green",
    maths: "green",
    computer: "green",
    envScience: "green",
    img: "https://imageplaceholder.net/300",
    key: 1,
  },
  {
    id: "EA123793",
    student_name: "Joann",
    rollNo: "Roll No : 35012",
    department: "Management",
    english: "green",
    spanish: "red",
    physics: "green",
    chemistry: "green",
    maths: "green",
    computer: "green",
    envScience: "green",
    designation: "Receptionist",
    img: "https://imageplaceholder.net/300",
    key: 2,
  },
  {
    id: "EA123792",
    student_name: "Kathleen",
    rollNo: "Roll No : 35011",
    english: "green",
    spanish: "green",
    physics: "green",
    department: "Management",
    chemistry: "green",
    maths: "green",
    computer: "green",
    envScience: "green",
    designation: "Admin",
    img: "https://imageplaceholder.net/300",
    key: 3,
  },
  {
    id: "EA123791",
    student_name: "Gifford",
    rollNo: "Roll No : 35010",
    english: "green",
    spanish: "green",
    physics: "green",
    department: "Management",
    chemistry: "green",
    maths: "blue",
    computer: "green",
    envScience: "green",
    designation: "Admin",
    img: "https://imageplaceholder.net/300",
    key: 4,
  },
  {
    id: "EA123790",
    student_name: "Lisa",
    rollNo: "Roll No : 35009",
    english: "green",
    spanish: "green",
    physics: "blue",
    chemistry: "green",
    maths: "green",
    department: "Finance",
    computer: "green",
    envScience: "green",
    designation: "Accountant",
    img: "https://imageplaceholder.net/300",
    key: 5,
  },
  {
    id: "EA123789",
    student_name: "Ralph",
    rollNo: "Roll No : 35008",
    english: "green",
    spanish: "green",
    physics: "green",
    chemistry: "green",
    maths: "green",
    department: "Management",
    computer: "green",
    envScience: "green",
    designation: "HR Manager",
    img: "https://imageplaceholder.net/300",
    key: 6,
  },
  {
    id: "EA123788",
    student_name: "Julie",
    rollNo: "Roll No : 35007",
    english: "green",
    spanish: "green",
    physics: "green",
    chemistry: "green",
    maths: "green",
    department: "Library",
    computer: "green",
    envScience: "green",
    designation: "Librarian",
    img: "https://imageplaceholder.net/300",
    key: 7,
  },
  {
    id: "EA123787",
    student_name: "Ryan",
    rollNo: "Roll No : 35006",
    english: "green",
    spanish: "red",
    physics: "green",
    chemistry: "green",
    maths: "green",
    department: "Transport",
    computer: "green",
    envScience: "green",
    designation: "Driver",
    img: "https://imageplaceholder.net/300",
    key: 8,
  },
  {
    id: "EA123786",
    student_name: "Susan",
    rollNo: "Roll No : 35004",
    english: "green",
    spanish: "green",
    physics: "green",
    chemistry: "green",
    department: "Finance",
    maths: "green",
    computer: "red",
    envScience: "green",
    designation: "Accounts Manager",
    img: "https://imageplaceholder.net/300",
    key: 9,
  },
  {
    id: "EA123785",
    student_name: "Richard",
    rollNo: "Roll No : 35003",
    english: "green",
    spanish: "green",
    physics: "green",
    chemistry: "green",
    department: "Management",
    maths: "green",
    computer: "green",
    envScience: "green",
    designation: "Receptionist",
    img: "https://imageplaceholder.net/300",
    key: 10,
  },
];
